import { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { IEquipoComboRequest } from "../../../Interfaces/IEquipo";
import { EquipoService } from "../../../services/auxiliar/EquipoService";
import TipoEquipoService from "../../../services/ListaVerificacion/TipoEquipoService";
import { IFilterTipoEquipo } from "../../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo";

interface UTEquipo {
    isOpen: boolean;
    equipoAuxiliar?: boolean
}

export const useComboTipoEquipos = (props: UTEquipo) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filterTipoE, setFilterTipoE] = useState<IFilterTipoEquipo>({
        search: "",
        equipoAuxiliar: props.equipoAuxiliar ?? false
    });
    const [dataComboTipoE, setDataComboTipoE] = useState<IComboBoxOption[]>([]);
    const comboBoxRefTipoE = useRef<IComboBox>(null);

    const onClickComboEquipo = () => comboBoxRefTipoE.current?.focus(true);

    const onChangeTipoE = (value: any) => {
        setFilterTipoE({ ...filterTipoE, search: value });
    }
    const _onkeyUpSearchTipoE = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefTipoE.current?.focus(false);
            setFilterTipoE({
                search: "",
                equipoAuxiliar: props.equipoAuxiliar ?? false
            });
        } else {
            let { value } = event?.target as HTMLInputElement;
            setFilterTipoE({ ...filterTipoE, search: value });
        }
    };

    const listarComboTipoE = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        TipoEquipoService.ListaCombo(filterTipoE, newController).then((res) => {
            if (res.status === 200) {
                setDataComboTipoE(res.data);
            }
        });
    };

    useEffect(() => {
        if (filterTipoE.search != "") {
            listarComboTipoE()
        }
    }, [filterTipoE.search])

    useEffect(() => {
        if (props.isOpen) {
            listarComboTipoE();
        }
    }, [props.isOpen]);

    return {
        dataComboTipoE,
        onClickComboEquipo,
        _onkeyUpSearchTipoE,
        comboBoxRefTipoE,
        setFilterTipoE,
        filterTipoE,
        onChangeTipoE,
        listarComboTipoE
    };
}

